import AdminLayout from '@/components/admin/AdminLayout';
import { TransferRequestsManager } from '@/components/admin/TransferRequestsManager';

export default function AdminTransfersPage() {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Patient Transfers</h1>
          <p className="text-muted-foreground">
            Review and manage patient transfer requests between agencies
          </p>
        </div>

        <TransferRequestsManager />
      </div>
    </AdminLayout>
  );
}
